import { useState, useEffect } from "react";

import url from "../../../../assets/svg/url.svg";
import download from "../../../../assets/svg/download.svg";
import fav from "../../../../assets/svg/favActive.svg";
import FileIcon from "./FileIcon";
import FileSaver from "file-saver";
import info from "../../../../assets/svg/info.svg";
import VideoPop from "../../layout/VideoPop";
import document from "../../../../assets/svg/documentActive.svg";
import API from "../../../../helpers/endpointService";
import { useDispatch } from "react-redux";
import { rightBarOpen } from "../../../../redux/action/Action";
import AudioPopup from "../../layout/AudioPop";
import Breadcrumbs from "../BreadGrumbs";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import formats from "../../../../helpers/MediaFormats";
import {
  GET_DOWNLOAD_FILE,
  POST_DOWNLOAD_MULTIPLE_FILE,
  GET_FILES_URL,
  POST_GET_FILES,
  POST_ADD_FAVOURITES,
  DELETE_FAVORITES,
} from "../../../../helpers/endpointService";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { PulseLoader } from "react-spinners";
import { logoutFunction } from "../../../../components/custom/commonFunction";

import "react-toastify/dist/ReactToastify.css";

export default function Folder3() {
  const userId = localStorage.getItem("UserId");
  const nav = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { docId } = useParams();
  const [isPlayVideo, setPlayVideo] = useState(false);
  const [isPlayAudio, setPlayAudio] = useState(false);
  const [videoSrc, setVideoSrc] = useState();
  const [audioSrc, setAudioSrc] = useState("");
  const [fileSelected, setFileSelected] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [isMobile, setisMobile] = useState(false);
  const [iswebMobile, setWebMobile] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [category2, setCategory2] = useState();
  const [filterfav, setFilterfav] = useState([]);
  const [favfile, setFavfile] = useState([]);

  useEffect(() => {
    fetchData();

    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  }, []);

  const resize = () => {
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }

    if (window.innerWidth < 400) {
      setWebMobile(true);
    } else {
      setWebMobile(false);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    let apiUrl = `${POST_GET_FILES}?docId=${docId}&userId=${userId}`;
    const pageDetails = {
      pageNumber: 1,
      pageSize: 20,
    };

    axios({
      method: "POST",
      url: apiUrl,
      data: pageDetails,
    })
      .then((response) => {
        setLoader(false);
        if (response?.status === 200) {
          setCategory2(response.data);
          setIsCheckAll(false);
          setFileSelected([]);
        }
      })
      .catch((err) => {
        setLoader(false);
        logoutFunction(err?.response?.status);
      });
  };

  const handleFileOpen = (id, type) => {
    if (id) {
      setLoader(true);

      let fileUrl = null;
      const fetchFileUrl = async () => {
        let fileSrcUrl = `${GET_FILES_URL}?fileId=${id}`;
        await axios
          .get(fileSrcUrl)
          .then((response) => {
            if (response?.status === 200) {
              fileUrl = response.data;
              setLoader(false);
              if (fileUrl) {
                const fileType =
                  type === "url" ? type : fileUrl.split(".").pop();
                const supportedFormats = Object.values(formats).flat();

                if (supportedFormats.includes(fileType)) {
                  const findKeyByValue = (value, obj) => {
                    for (let key in obj) {
                      if (obj[key].includes(value)) {
                        return key;
                      }
                    }
                    return null;
                  };

                  const fileTypeKey = findKeyByValue(fileType, formats);

                  if (fileTypeKey) {
                    switch (fileTypeKey) {
                      case "video":
                        setPlayVideo(true);
                        setVideoSrc(fileUrl);
                        break;
                      case "audio":
                        setPlayAudio(true);
                        setAudioSrc(fileUrl);
                        break;
                      case "word":
                      case "pdf":
                      case "ppt":
                      case "zip":
                      case "xlsx":
                      case "image":
                      case "url":
                        window.open(fileUrl);
                        break;
                      default:
                        console.error(`Unsupported file type: ${fileType}`);
                    }
                    return;
                  } else {
                    console.error(`Unsupported file type: ${fileType}`);
                  }
                } else {
                  console.error(`Unsupported file type: ${fileType}`);
                }
              }
            }
          })
          .catch((err) => {
            setLoader(false);
            logoutFunction(err?.response?.status);
          });
      };
      fetchFileUrl();
    }
  };

  /////////////////////////////////// Checkbox handling ///////////////////////////////////
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setFileSelected(category2?.values?.map((list) => list.id));

    if (isCheckAll) {
      setFileSelected([]);
    }
  };
  useEffect(() => {
    if (fileSelected?.length > 0) {
      const filt = category2.values.filter((e) => e.isFavourite == true);
      const filefav = filt.filter((e) => fileSelected.includes(e.id));
      setFilterfav(filefav);

      const filefilt = filefav.map((e) => e.favouriteId);
      setFavfile(filefilt);
    }
    if (fileSelected?.length === 0 && isCheckAll) {
      setIsCheckAll(false);
    }
  }, [fileSelected]);

  const handleChangeChecked = (id) => {
    if (fileSelected?.includes(id)) {
      setFileSelected(fileSelected.filter((item) => item !== id));
    } else setFileSelected([...fileSelected, id]);
  };

  ////////////////////////////////////////  Media popup close /////////////////////////////////
  const handleCloseModal = () => {
    setPlayAudio(false);
    setPlayVideo(false);
  };

  ////////////////////////////////////////  RightBar open /////////////////////////////////////
  const openRightBar = (type) => {
    if (type === "properties") dispatch(rightBarOpen(type, docId));
  };

  ////////////////////////////////////// Add favourite handling ///////////////////////////////
  const addFavorite = async () => {
    if (fileSelected) {
      setLoader(true);
      // const filt=category2.values.filter((e)=>e.isFavourite==true);
      // const filefav=filt.filter((e)=>fileSelected.includes(e.id))
      // setFilterfav(filefav)
      let addFavApiUrl = `${POST_ADD_FAVOURITES}?userId=${userId}`;
      if (filterfav.length === 0) {
        await axios({
          method: "POST",
          url: addFavApiUrl,
          data: fileSelected,
        })
          .then((response) => {
            setLoader(false);
            if (response?.status === 200) {
              if (response.data == "file is already in favourites") {
                toast.warn("File is already in favourites", {
                  position: toast.POSITION.TOP_RIGHT,
                  color: "#fff",
                });
              }
              if (response.data == "document is not published") {
                toast.error("Obsolete document can't be add as a favourite.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
              } else {
                toast.success("Added to favourites", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
              }

              fetchData();
            }
          })
          .catch((err) => {
            setLoader(false);
            logoutFunction(err?.response?.status);
          });
      } else {
        toast.warn("File is already in favourites", {
          position: toast.POSITION.TOP_RIGHT,
          color: "#fff",
        });
        setLoader(false);
      }
    }
  };

  const removeFavouriteMessage = async () => {
    const usersId = userId * 1;
    if (fileSelected) {
      setLoader(true);
    }
    let apiUrl = `${API.DELETE_FAVORITES}?userId=${usersId}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: favfile,
    })
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          toast.success("Removed successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          fetchData();
          // this.state.favouriteArryList = [];
          // this.state.favoritesDocumentList = [];
          // this.state.favouritesFilesList = [];
          // this.setState({});
          // this.GetFavouritesList();
        } else {
        }
      })
      .catch((error) => {
        setLoader(false);
        logoutFunction(error?.response?.status);
      });
  };

  ///////////////////////////////////////// Files download ///////////////////////////////////
  const downloadFiles = () => {
    setLoader(true);

    if (fileSelected?.length === 1) {
      // const fileType = category2?.find()
      // if(fileType !== "url") {
      const fetchData = async () => {
        let apiUrl = `${GET_DOWNLOAD_FILE}?fileId=${fileSelected[0]}`;
        await axios
          .get(apiUrl, { responseType: "blob" })
          .then((response) => {
            if (response?.status === 200) {
              let blob = "";
              blob = new Blob([response.data], { type: response.data.type });
              FileSaver.saveAs(blob);

              toast.success("Downloaded successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
              });
              setLoader(false);
            }
          })
          .catch((err) => {
            setLoader(false);
            toast.error("Download falied", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
            logoutFunction(err?.response?.status);
          });
      };
      fetchData();
      // }
    } else if (fileSelected?.length > 1) {
      const filteredIds = fileSelected.filter((id) => {
        const obj = category2?.values?.find((item) => item.id === id);
        return !obj || (obj && obj.fileType !== "url");
      });

      axios({
        method: "POST",
        url: POST_DOWNLOAD_MULTIPLE_FILE,
        data: filteredIds,
        responseType: "blob",
      })
        .then((response) => {
          setLoader(false);
          if (response?.status === 200) {
            let blob2 = "";
            blob2 = new Blob([response.data], { type: response.data.type });
            FileSaver.saveAs(blob2);
            toast.success("Downloaded successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
          }
        })
        .catch((err) => {
          setLoader(false);
          toast.error("Download falied", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
          logoutFunction(err?.response?.status);
        });
    }
  };

  return (
    <>
      <ToastContainer
        limit={1}
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {isLoader && (
        <div className="spinner_overlay">
          <div className="loader">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        </div>
      )}

      <div className="titleContainer">
        <div className="title">
          <img src={document} />
          <span>Documents</span>
        </div>
        <div className="functionButtons">
          {fileSelected?.length >= 1 && (
            <div onClick={downloadFiles}>
              <img src={download} alt="" />
              <span>Download</span>
            </div>
          )}
          {fileSelected?.length >= 1 &&
            (filterfav.length === 0 ? (
              <div onClick={addFavorite}>
                <img src={fav} alt="" />
                <span>Add favourites</span>
              </div>
            ) : (
              <div className="disable">
                <img src={fav} alt="" />
                <span>Add favourites</span>
              </div>
            ))}
          {fileSelected?.length >= 1 &&
            (filterfav.length !== 0 &&
            filterfav.length === fileSelected.length ? (
              <div onClick={removeFavouriteMessage}>
                <img src={fav} alt="" />
                <span>Remove favourites</span>
              </div>
            ) : (
              <div className="disable">
                <img src={fav} alt="" />
                <span>Remove favourites</span>
              </div>
            ))}
          <div onClick={() => openRightBar("properties")}>
            <img src={info} alt="" />
            <span>Properties</span>
          </div>
        </div>

        <Breadcrumbs location={location} />
      </div>

      {category2?.values?.length > 0 ? (
        <div
          className={`fileList2 table-responsive  table-fixed-header table-responsive-height file-name-mt`}
          //style={{ marginTop: !isMobile ? "174px" : "" }}
        >
          {/* <div
          className={`${
            isMobile ? " table-mobile-height" : " table-height"
          } fileList2 table-responsive  table-fixed-header table-responsive-height file-name-mt`}
        ></div> */}
          <table className="fileListTable2">
            <thead className="thead-sticky breadgrump thead-color">
              <tr>
                <td className="wid-7">
                  {/* <label className="checkbox-container"> */}
                  <input
                    type="checkbox"
                    checked={isCheckAll}
                    name="request"
                    onChange={() => handleSelectAll()}
                  />
                  {/* <span className="checkmark"></span> */}
                  {/* </label>. */}
                </td>
                <td /* style={{ display: 'flex' }} */>
                  <span>File name</span>
                </td>
                <td></td>
                {/* <td><span>Document no.</span></td> */}
                {/* <td><span>Author</span></td> */}
                {/* <td><span>Published date / time</span><img src={downArrow} alt='' /></td> */}
              </tr>
            </thead>

            <tbody>
              {category2?.values?.map((list, index) => {
                return (
                  <tr
                    key={index}
                    onDoubleClick={() => handleChangeChecked(list.id)}
                  >
                    <td>
                      <input
                        type="checkbox"
                        value={list.id}
                        checked={fileSelected?.includes(list.id) ? true : false}
                        onChange={() => handleChangeChecked(list.id)}
                        name="request"
                      />
                    </td>
                    <td style={{ display: "flex" }} title={list.fileName}>
                      <div style={{ paddingRight: "10px" }}>
                        {list.fileType === "url" ? (
                          <img src={url} alt="" />
                        ) : (
                          <FileIcon fileName={list.fileName} />
                        )}
                      </div>
                      <span
                        onClick={() => handleFileOpen(list.id, list.fileType)}
                        className="fileName"
                      >
                        {list.fileName}
                      </span>
                    </td>

                    <td></td>
                    {list.isFavourite && (
                      <img
                        style={{ right: "50px", position: "relative" }}
                        src={fav}
                        width={18}
                      />
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <>
          <span className="empty2">{category2 && "Folder is empty"}</span>
        </>
      )}

      {isPlayVideo && (
        <VideoPop videoUrl={videoSrc} onClose={handleCloseModal} />
      )}

      {isPlayAudio && (
        <AudioPopup audioUrl={audioSrc} onClose={handleCloseModal} />
      )}
    </>
  );
}
